import { BTS2025ScrollingBannerContent } from './bts-2025-scrolling-banner-content'
import styles from './bts-2025-scrolling-banner-shared.module.scss'

export const BTS2025ScrollingBanner = () => {
  return (
    <div className={styles.outerContainer}>
      <div className={styles.wrapper}>
        <BTS2025ScrollingBannerContent />
      </div>
    </div>
  )
}
